import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Box,FormControl,TextField, InputAdornment, Typography} from "@mui/material";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faUnlockKeyhole } from "@fortawesome/free-solid-svg-icons";
import { faArrowRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash, faEye } from "@fortawesome/free-regular-svg-icons";
import { motion } from "framer-motion";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Login = () => {
  const [eyeToggle, setEyetoggle] = useState(true);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); // Loading state to indicate request
  const [error, setError] = useState(""); // Error state for any error messages

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(""); // Reset error message

    // Form data to be sent to the backend
    const loginData = { email, password };

    try {
      // Send data to the backend API (replace with your backend URL)
      const response = await fetch('http://localhost:5000/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData),
      });

      const data = await response.json();

      if (response.ok) {
        // Handle successful login
        console.log('User logged in:', data);
         window.location.href = '/about'
         toast.success('User login!', {
          autoClose: 5000,  // Closes after 5 seconds
        });
        setEmail("");
        setPassword("");
      } else {
        // Handle error response from backend
        const errorMessage = data.message || (response.status === 404 ? 'User not found. Please check your email or register if you don\'t have an account.' : 'Invalid credentials');
        setError(errorMessage);
        toast.error(errorMessage);
      }
    } catch (err) {
      // Handle network or unexpected errors
      setError(`An error occurred. Please try again. ${error}`);
      console.error('Error during login:', err);
    } finally {
      setLoading(false);
    }
  };



  const passwordToggler = () => {
    setEyetoggle(!eyeToggle)
  }
  return (
    <>
        <Box className="form" style={{zIndex: '2', position: 'relative'}}>
            <Container>
              <Row>
                <Col lg="12">
                  <motion.div className="loginMotion">
                    <Form className="loginform" onSubmit={handleSubmit}>
                      <Typography variant="body1" component="p">Welcome Back</Typography>
                      <Typography variant="h2">Log In</Typography>
                      <FormControl fullWidth>
                        <Typography variant="body1" component="label">Email</Typography>
                        <TextField id="" className="authInput" label="Email" placeholder="Enter Your Email" value={email}
          onChange={(e) => setEmail(e.target.value)} variant="outlined" hiddenLabel="true" InputProps={{startAdornment:(<InputAdornment position="start"><FontAwesomeIcon icon={faAt} /></InputAdornment> )}} />
                      </FormControl>

                      <FormControl fullWidth>
                        <Typography variant="body1" component="label">Password</Typography>
                        <TextField id="" type={eyeToggle ? 'password' : 'text'} className="authInput relative" label="Password" placeholder="Enter Your Password"  value={password}
          onChange={(e) => setPassword(e.target.value)}variant="outlined" hiddenLabel="true" InputProps={{startAdornment:(<InputAdornment position="start"><FontAwesomeIcon icon={faUnlockKeyhole} /></InputAdornment> )}} />
                        <FontAwesomeIcon className="passEye" icon={eyeToggle ? faEyeSlash : faEye} onClick={passwordToggler}/>
                      </FormControl>
                      <Box className='btnWrapper text-end'>
                        <Button style={{opacity:'0.8', cursor:'not-allowed', pointerEvents:'none'}} variant="link" type="submit" className="coverBtn btnIcon authBtn my-3" disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'} <span> <FontAwesomeIcon icon={faArrowRightToBracket} /></span></Button>
                      </Box>                      
                    </Form>
                  </motion.div>
                </Col>
              </Row>
            </Container>
          </Box>
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

export default Login;



